'use client';

import { c as _c } from "react/compiler-runtime";
import { z } from '@repo/schema';
import { GetCurrencyCodeSchema } from '@repo/schema/currency';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@repo/ui/components';
import { useCurrencies } from '@/app/@protected/_hooks/use-currencies.ts';
export type CurrencyCode = z.infer<typeof GetCurrencyCodeSchema>;
interface CurrencySelectProps {
  disabled?: boolean;
  onChange: (_currency: CurrencyCode) => void;
  /** May be a stored code the API no longer accepts; it is shown as is. */
  value: string;
}
export const CurrencySelect = t0 => {
  const $ = _c(14);
  const {
    disabled,
    onChange,
    value
  } = t0;
  const currencies = useCurrencies();
  let t1;
  if ($[0] !== onChange) {
    t1 = next => {
      const currency = GetCurrencyCodeSchema.safeParse(next).data;
      if (currency) {
        onChange(currency);
      }
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== value) {
    t2 = <SelectTrigger disabled={disabled} data-sentry-element="SelectTrigger" data-sentry-source-file="currency-select.tsx">{value}</SelectTrigger>;
    $[2] = disabled;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currencies) {
    t3 = currencies.map(_temp);
    $[5] = currencies;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SelectContent align="end" alignItemWithTrigger={false} className="min-w-24" positionMethod="fixed" data-sentry-element="SelectContent" data-sentry-source-file="currency-select.tsx">{t3}</SelectContent>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t4 || $[12] !== value) {
    t5 = <Select onValueChange={t1} value={value} data-sentry-element="Select" data-sentry-component="CurrencySelect" data-sentry-source-file="currency-select.tsx">{t2}{t4}</Select>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(currency_0) {
  return <SelectItem key={currency_0.alias} value={currency_0.iso_code}>{currency_0.iso_code} <span className="text-muted-foreground">{currency_0.title}</span></SelectItem>;
}